<template>
  <v-card flat class="position-relative" style="min-height: 380px;">
    <!-- لودینگ اختصاصی تب -->

    <v-card-text class="pt-4">
          <!-- <v-overlay :value="loading" absolute z-index="10" color="white" opacity="0.85">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ef394e"
      />
    </v-overlay> -->

      <v-form ref="form" v-model="isValid" @submit.prevent="submitForm">
        <v-row dense>
          <!-- محصول اصلی سامانه -->
          <v-col cols="12">
            <v-autocomplete
              ref="productSelect"
              v-model="payload.product_id"
              :items="localProducts"
              :loading="isLoadingProducts"
              :search-input.sync="searchProduct"
              item-value="id"
              item-text="title"
              label="محصول سامانه (جستجو با نام یا کد)"
              outlined
              dense
              clearable
              required
              :rules="[v => !!v || 'انتخاب محصول سامانه الزامی است']"
              prepend-inner-icon="mdi-magnify"
              placeholder="نام یا کد محصول سامانه را تایپ کنید..."
              no-filter
            >
              <template v-slot:selection="{ item }">
                <div class="d-flex align-center text-truncate py-1">
                  <v-avatar size="26" rounded="sm" class="elevation-1 border ml-2 flex-shrink-0" color="grey lighten-4">
                    <v-img v-if="getItemImage(item)" :src="getItemImage(item)" aspect-ratio="1" contain />
                    <v-icon v-else x-small color="grey lighten-1">mdi-image-outline</v-icon>
                  </v-avatar>
                  <v-chip x-small color="primary" class="ml-1 font-weight-bold">ID-{{ item.id }}</v-chip>
                  <span class="text-truncate">{{ item.title }}</span>
                </div>
              </template>

              <template v-slot:item="{ item }">
                <v-list-item-avatar size="42" rounded="lg" class="elevation-1 border my-1 ml-2" color="grey lighten-4">
                  <v-img v-if="getItemImage(item)" :src="getItemImage(item)" aspect-ratio="1" contain>
                    <template #placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate size="16" color="grey lighten-1" />
                      </v-row>
                    </template>
                  </v-img>
                  <v-icon v-else small color="grey lighten-1">mdi-image-outline</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium text-body-2 mb-1" style="line-height: 1.4;">
                    {{ item.title }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="d-flex align-center">
                    <v-chip x-small color="primary" outlined class="font-mono font-weight-bold">
                      کد: {{ item.id }}
                    </v-chip>
                    <span v-if="item.sku" class="text-caption grey--text mr-2">
                      SKU: {{ item.sku }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- تنوع اصلی محصول سامانه -->
          <v-col cols="12" v-if="localSKUProducts.length > 0">
            <v-autocomplete
              v-model="payload.product_sku_id"
              :items="localSKUProducts"
              :loading="isLoadingSKUProducts"
              item-value="id"
              item-text="title"
              label="تنوع سامانه (جستجو با نام یا کد)"
              outlined
              dense
              clearable
              required
              :rules="[v => !!v || 'انتخاب تنوع محصول سامانه الزامی است']"
              prepend-inner-icon="mdi-shape-outline"
              placeholder="نام یا کد تنوع سامانه را تایپ کنید..."
            >
              <template v-slot:selection="{ item }">
                <div class="d-flex align-center text-truncate py-1">
                  <v-avatar size="26" rounded="sm" class="elevation-1 border ml-2 flex-shrink-0" color="grey lighten-4">
                    <v-img v-if="getSkuImage(item)" :src="getSkuImage(item)" aspect-ratio="1" contain />
                    <v-icon v-else x-small color="grey lighten-1">mdi-image-outline</v-icon>
                  </v-avatar>
                  <v-chip x-small color="secondary" class="ml-1 font-weight-bold">ID-{{ item.id }}</v-chip>
                  <span class="text-truncate">{{ item.title || item.sku }}</span>
                </div>
              </template>

              <template v-slot:item="{ item }">
                <v-list-item-avatar size="42" rounded="lg" class="elevation-1 border my-1 ml-2" color="grey lighten-4">
                  <v-img v-if="getSkuImage(item)" :src="getSkuImage(item)" aspect-ratio="1" contain />
                  <v-icon v-else small color="grey lighten-1">mdi-image-outline</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium text-body-2 mb-1">
                    {{ item.title || item.sku || ('تنوع ' + item.id) }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="d-flex align-center flex-wrap gap-1">
                    <v-chip x-small color="secondary" outlined class="font-mono font-weight-bold ml-1">
                      ID: {{ item.id }}
                    </v-chip>
                    <v-chip v-if="item.sku" x-small color="grey darken-1" outlined class="font-mono ml-1">
                      {{ item.sku }}
                    </v-chip>
                    <span v-if="item.color_title || item.color?.title" class="text-caption grey--text mr-1">
                      رنگ: {{ item.color_title || item.color?.title }}
                    </span>
                    <span v-if="item.size_title || item.size?.title" class="text-caption grey--text mr-1">
                      سایز: {{ item.size_title || item.size?.title }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- تعداد در بسته -->
          <v-col cols="12">
            <v-text-field
              v-model.number="payload.package_quantity"
              label="تعداد در بسته"
              outlined
              dense
              type="number"
              min="1"
              required
              :rules="[
                v => !!v || 'وارد کردن تعداد در بسته الزامی است',
                v => v > 0 || 'تعداد باید بیشتر از صفر باشد'
              ]"
              prepend-inner-icon="mdi-package-variant-closed"
            />
          </v-col>

          <!-- هزینه هر بسته -->
          <v-col cols="12">
            <PriceInput
              v-model="payload.package_cost"
              label="هزینه هر بسته"
              prepend-inner-icon="mdi-currency-usd"
              outlined
              dense
              :rules="[v => (v !== null && v !== '' && v !== undefined) || 'وارد کردن هزینه هر بسته الزامی است']"
            />
          </v-col>

          <!-- گام قیمت -->
          <v-col cols="12">
            <div class="d-flex align-start">
              <PriceInput
                v-model="payload.price_step"
                label="گام قیمت"
                prepend-inner-icon="mdi-step"
                outlined
                dense
                class="flex-grow-1"
                :rules="[v => (v !== null && v !== '' && v !== undefined) || 'وارد کردن گام قیمت الزامی است']"
              />
              <PriceCalculator 
                class="mr-2 mt-1"
                :product-id="payload.product_id"
                :sku-id="payload.product_sku_id"
                :form-data="payload"
              />
            </div>
          </v-col>

          <!-- روش ارسال -->
          <v-col cols="12">
            <v-select
              v-model="payload.shipping_method"
              label="روش ارسال"
              :items="shipping_methods"
              outlined
              dense
              style="border-radius: 8px"
              :menu-props="{ offsetY: true }"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions class="grey lighten-4 pa-4 d-flex align-center">
      <v-btn class="btn-delete rounded-lg" @click="$emit('close')">
        <v-icon left>mdi-close</v-icon>
        انصراف
      </v-btn>

      <v-btn
        v-if="isLinked"
        outlined
        class="btn-refund rounded-lg mr-2"
        :loading="isUnlinking"
        :disabled="isSubmitting"
        @click="unlinkProduct"
      >
        <v-icon left>mdi-link-off</v-icon>
        قطع اتصال
      </v-btn>

      <v-spacer />

      <v-btn
        class="btn-get-code rounded-lg"
        :loading="isSubmitting"
        :disabled="!isValid || isUnlinking || loading"
        @click="submitForm"
      >
        <v-icon left>mdi-link-variant-plus</v-icon>
        تایید و اتصال
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import PriceInput from "@/view/pages/uiBeautifier/priceInput";
import PriceCalculator from "../../components/PriceCalculator.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "linkDigiProductModel_single",
  components: {
    PriceInput,
    PriceCalculator,
    AtomSpinner,
  },
  props: {
    productDigi: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      shipping_methods: [
        { text: "ارسال دیجی/فروشنده/سه ساعته", value: "all" },
        { text: "ارسال فروشنده / سه ساعته", value: "both" },
      ],
      isValid: false,
      isSubmitting: false,
      isUnlinking: false,
      isLinked: false,
      listingId: null,

      localProducts: [],
      isLoadingProducts: false,
      searchProduct: null,
      searchTimeout: null,

      localSKUProducts: [],
      isLoadingSKUProducts: false,

      payload: {
        product_id: null,
        product_sku_id: null,
        package_quantity: 1,
        package_cost: 20000,
        shipping_method: "both",
        price_step: 20000,
      },
    };
  },
  watch: {
    productDigi: {
      deep: true,
      handler() {
        this.initData();
      }
    },
    searchProduct(val) {
      if (!val || val.length < 2) return;
      if (this.isLoadingProducts) return;

      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchLocalProducts(val);
      }, 500);
    },
    "payload.product_id"(newVal, oldVal) {
        if (oldVal && newVal !== oldVal && !this.loading) {
              this.payload.product_sku_id = null;
              this.localSKUProducts = [];
            }
            if (newVal) {
              this.fetchLocalSKUProducts(newVal);
            }
  },
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      this.loading = true;
      try {
        await Promise.all([
          this.fetchLocalProducts(""),
          this.fetchData(),
        ]);
      } finally {
        this.loading = false;
        this.openProductDropdownIfEmpty();
      }
    },

    getSkuImage(sku) {
      if (!sku) return "";
      let img = sku.main_image?.url || sku.image || sku.thumbnail || sku.cover || sku.img_url;
      if (!img && (Array.isArray(sku.images) || Array.isArray(sku.gallery))) {
        const list = sku.images || sku.gallery;
        if (list.length > 0) {
          const first = list[0];
          img = typeof first === "string" ? first : (first?.url || first?.src || first?.path);
        }
      }
      if (!img && this.payload.product_id) {
        const parentProduct = this.localProducts.find(p => p.id === this.payload.product_id);
        if (parentProduct) img = this.getItemImage(parentProduct);
      }
      if (!img) return "";
      if (typeof img === "string" && !img.startsWith("http") && !img.startsWith("data:")) {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || window.location.origin;
        return `${baseUrl.replace(/\/+$/, "")}/${img.replace(/^\/+/, "")}`;
      }
      return img;
    },

    getItemImage(item) {
      if (!item) return "";
      let img = item.main_image?.url || item.image || item.cover || item.cover_image || item.img_url;
      if (!img && (Array.isArray(item.images) || Array.isArray(item.gallery))) {
        const list = item.images || item.gallery;
        if (list.length > 0) {
          const first = list[0];
          img = typeof first === "string" ? first : (first?.url || first?.src || first?.path);
        }
      }
      if (!img) return "";
      if (typeof img === "string" && !img.startsWith("http") && !img.startsWith("data:")) {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || window.location.origin;
        return `${baseUrl.replace(/\/+$/, "")}/${img.replace(/^\/+/, "")}`;
      }
      return img;
    },

    openProductDropdownIfEmpty() {
      this.$nextTick(() => {
        if (!this.payload.product_id && this.$refs.productSelect) {
          this.$refs.productSelect.focus();
        }
      });
    },

    async fetchData() {
      const variantId = this.productDigi?.variant_id || this.productDigi?.id;
      if (!variantId) return;

      let calculatedShipping = "both";

      try {
        const res2 = await this.$api.get(`/v1/marketplace-listings/digi/get-variant`, {
          params: { variant_id: variantId }
        });
        const vData = res2.data?.data?.variant || res2.data?.data || res2.data?.variant;

        if (vData) {
          const isFbd = vData.is_fbd_active === true || 
                        vData.is_fbd_active === 1 || 
                        vData.is_fbd_active === "1" || 
                        vData.is_fbd_active === "true";

          calculatedShipping = isFbd ? 'all' : 'both';
        }
      } catch (variantErr) {
        console.warn("خطا در دریافت وضعیت شیپینگ تنوع دیجی‌کالا:", variantErr);
      }

      this.$set(this.payload, 'shipping_method', calculatedShipping);

      try {
        const res = await this.$api.get(`/v1/marketplace-listings/digi/get-listing`, {
          params: { variant_id: variantId, marketplace: 'digikala' }
        });

        const resData = res?.data?.data;
        const listing = resData?.listing;

        this.isLinked = listing?.status === "linked";
        this.listingId = listing?.id || null;

        if (listing && listing.product_id) {
          const pId = Number(listing.product_id);

          if (!this.localProducts.some(p => p.id === pId)) {
            this.localProducts.unshift({
              id: pId,
              title: listing?.product?.title || listing?.metadata?.title || `محصول شماره ${pId}`,
              image: listing?.product?.image || listing?.product?.thumbnail || listing?.metadata?.image_src || null
            });
          }

          await this.fetchLocalSKUProducts(pId);

          const finalShipping = listing.shipping_method || calculatedShipping;

          this.payload = {
            product_id: pId,
            product_sku_id: listing.product_sku_id ? Number(listing.product_sku_id) : null,
            package_quantity: listing.package_quantity ?? 1,
            package_cost: listing.package_cost ?? 20000,
            shipping_method: finalShipping,
            price_step: listing.price_step ?? 20000,
          };
        } else {
          this.payload.shipping_method = calculatedShipping;
        }
      } catch (error) {
        console.error("خطا در بازیابی اطلاعات اتصال تنوع", error);
        this.isLinked = false;
        this.listingId = null;
        this.payload.shipping_method = calculatedShipping;
      }
    },

    async fetchLocalProducts(searchQuery) {
      this.isLoadingProducts = true;
      try {
        const { data } = await this.$api.get(`/v1/products/list`, {
          params: { search: searchQuery },
        });
        this.localProducts = data?.data?.data || data?.data || data || [];
      } catch (error) {
        console.error("خطا در دریافت محصولات سامانه", error);
      } finally {
        this.isLoadingProducts = false;
      }
    },

    async fetchLocalSKUProducts(productId) {
      this.isLoadingSKUProducts = true;
      try {
        const { data } = await this.$api.get(`/v1/products/${productId}/sku-list`);
        this.localSKUProducts = data?.data || data || [];
      } catch (error) {
        console.error("خطا در دریافت لیست تنوع‌ها", error);
        this.localSKUProducts = [];
      } finally {
        this.isLoadingSKUProducts = false;
      }
    },

    async unlinkProduct() {
      const confirmed = this.$modal?.yesNo
        ? await this.$modal.yesNo("آیا از قطع اتصال این تنوع از محصول سامانه اطمینان دارید؟")
        : confirm("آیا از قطع اتصال این تنوع از محصول سامانه اطمینان دارید؟");

      if (!confirmed) return;

      this.isUnlinking = true;
      try {
        const variantId = Number(this.productDigi?.variant_id || this.productDigi?.id);
        await this.$api.post(`v1/marketplace-listings/unlink-by-variant`, {
          marketplace: "digikala",
          external_variant_id: variantId
        });

        this.$toast?.success("اتصال با موفقیت قطع شد.");
        this.$emit("saved");
        this.$emit("close");
      } catch (error) {
        this.$toast?.error(error.response?.data?.message || "خطا در قطع اتصال");
      } finally {
        this.isUnlinking = false;
      }
    },

    async submitForm() {
      if (this.$refs.form && !this.$refs.form.validate()) return;

      this.isSubmitting = true;
      try {
        const apiPayload = {
          digikala_variant_id: Number(this.productDigi?.variant_id || this.productDigi?.id),
          product_id: Number(this.payload.product_id),
          product_sku_id: this.payload.product_sku_id ? Number(this.payload.product_sku_id) : null,
          package_quantity: Number(this.payload.package_quantity) || 1,
          package_cost: Number(String(this.payload.package_cost || 0).replace(/,/g, "")),
          shipping_method: this.payload.shipping_method,
          price_step: Number(String(this.payload.price_step || 0).replace(/,/g, "")),
        };

        await this.$api.post("/v1/digikala/link-variants", apiPayload);

        this.$toast?.success("اتصال با موفقیت انجام شد.");
        this.$emit("saved");
        this.$emit("close");
      } catch (error) {
        this.$toast?.error(error.response?.data?.message || "خطا در اتصال");
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
